import { initialFabricCanvasContextValue } from './fabricCanvas.constants';
import { FabricCanvasContextType } from './fabricCanvas.types';

import { createTypeSafeContext } from '~/core/utils';

const [useFabricCanvasContext, FabricCanvasContext] =
  createTypeSafeContext<FabricCanvasContextType>(
    initialFabricCanvasContextValue
  );

export { useFabricCanvasContext, FabricCanvasContext };
